import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SignoCentroMedicoService } from 'src/app/services/entidades/signo-centros-medicos.service';

export interface CentrosDetalleModalData {
  titulo: string;
  filtros: any;
}

@Component({
  selector: 'app-centros-detalle-modal',
  templateUrl: './centros-detalle-modal.component.html',
  styleUrls: ['./centros-detalle-modal.component.scss']
})
export class CentrosDetalleModalComponent implements OnInit, OnDestroy {

  titulo = '';
  centros: any[] = [];
  total = 0;
  page = 0;
  pageSize = 10;
  isLoading = true;
  busqueda = '';
  private busquedaTimeout: any;

  constructor(
    public dialogRef: MatDialogRef<CentrosDetalleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CentrosDetalleModalData,
    private centroService: SignoCentroMedicoService,
  ) {
    this.titulo = data && data.titulo ? data.titulo : 'Centros';
  }

  ngOnInit() {
    this.cargar();
  }

  ngOnDestroy() {
    if (this.busquedaTimeout) { clearTimeout(this.busquedaTimeout); }
  }

  async cargar() {
    this.isLoading = true;
    try {
      const filtros = Object.assign({}, this.data.filtros, { page: this.page, pageSize: this.pageSize });
      if (this.busqueda) { filtros.busqueda = this.busqueda; }
      const resp = await this.centroService.getCentros(filtros);
      this.centros = resp.centros || [];
      this.total = resp.total || 0;
    } catch (e) {
      console.error('Error cargando centros del detalle:', e);
      this.centros = [];
      this.total = 0;
    } finally {
      this.isLoading = false;
    }
  }

  onBusqueda() {
    if (this.busquedaTimeout) { clearTimeout(this.busquedaTimeout); }
    this.busquedaTimeout = setTimeout(() => {
      this.page = 0;
      this.cargar();
    }, 350);
  }

  get totalPaginas() {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  }

  paginaAnterior() {
    if (this.page > 0) {
      this.page = this.page - 1;
      this.cargar();
    }
  }

  paginaSiguiente() {
    if (this.page + 1 < this.totalPaginas) {
      this.page = this.page + 1;
      this.cargar();
    }
  }

  cerrar() {
    this.dialogRef.close();
  }
}
